/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { BridgePermissions } from 'blb-types/blendBridge';
export const FALLBACK_ROUTE = '/profile';
const userHasPermission = (userPermissionIds, permission) => userPermissionIds.includes(BridgePermissions[permission]);
export const hasPermissions = (userType, userPermissionIds, requiredPermissions) => {
  if (!requiredPermissions) return true;
  let permissionName;
  // eslint-disable-next-line guard-for-in
  for (permissionName in requiredPermissions) {
    const guardedUserTypes = requiredPermissions[permissionName];
    // if the user is in the guardedUserTypes list and does not have permissions...
    if (guardedUserTypes.includes(userType) && !userHasPermission(userPermissionIds, permissionName)) {
      return false;
    }
  }

  // If all of the checks pass, permission is granted.
  return true;
};